import { Box, Typography } from '@material-ui/core'
import EmailIdPassword from '../../components/EmailIdPassword/index.js'
import { ENPHASE_INSTALLER_LOGIN_DISCLAIMER } from './constants.js'
import { useStyles } from './styles.js'
const UserSignIn = (props) => {
  const classes = useStyles()
  const { setLoading } = props
  return (
    <>
      <Box className={classes.logindisclaimer}>
        <Box>
          <Typography variant="subtitle2" classes={{ root: classes.root }}>
            {ENPHASE_INSTALLER_LOGIN_DISCLAIMER}
          </Typography>
        </Box>
      </Box>
      <EmailIdPassword setLoading={setLoading}></EmailIdPassword>
    </>
  )
}
export default UserSignIn
